module.exports = __webpack_public_path__ + "static/media/va.8a039d4f.svg";